import { Component, OnInit } from '@angular/core';
import {InfoApiService} from '../../../../services/rest-api/info.api.service';
import {ActivatedRoute, Router} from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import {HssResponse} from '../../../../services/rest-api/HssResponse';
import {HssErrorResponse} from '../../../../services/rest-api/HssErrorResponse';
import {StorageService} from '../../../../services/rest-api/storage.service';
import {SeoService} from '../../../../services/seo/seo.service';

@Component({
  selector: 'app-event',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {

  selEvent: any;
  safeURL: any;
  galleyData: any;
  loader=false;
  citeRepat: any[] = [1,2,3,4];
  imgCollection: any[] = [];

  constructor(private _info: InfoApiService,
              private _actRoute: ActivatedRoute,
              public sanitizer: DomSanitizer,
              private storage: StorageService,
              private seo: SeoService) {
  }

  ngOnInit(): void {
    this._actRoute.queryParams.subscribe(params => {
      // this.selEvent = JSON.parse(<any> params.event);
      const infoId = this._actRoute.snapshot.params.infoid;

      const localEventsData = this.storage.getData('infoData');
      const events = localEventsData ? JSON.parse(localEventsData): [];
      this.selEvent = this.getInfo(events, infoId);

      this.seo.setMeta(this.selEvent.title, this.selEvent.short_desc);

      if(this.selEvent.length==0){
        this.getInformationItem(infoId);
      }

      console.log('this.selEvent.id',infoId);
      this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl('this.selEvent.video');
      this.getGalleryImages(infoId);
    });
  }

  getInformationItem(id: number){
    this.loader = true;
    this._info.getInformation(id).subscribe (
      (response: HssResponse<any>) => {
        this.selEvent = response.body[0];
        this.loader = false;
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }


  getGalleryImages(infoId: number){
    this._info.getGalleyImages(infoId).subscribe (
      (response: HssResponse<any>) => {
        this.galleyData = response.body[0].slider.slider_contents;
        for(let img of this.galleyData){
          let imgArr = [
            {
              image: img.image,
              thumbImage: img.image,
              alt: img.title,
              title: img.title
            },
          ];
          this.imgCollection.push(...imgArr);
        }
      },
      (error: HssErrorResponse<any>) => {
        // Show the failed message
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
      }
    );
  }

  // load single info item from stored array
  getInfo(dataArray: any, infoId: string){
    const result:any[] = dataArray.filter(function(item:any){
      // Convert item id also to string for matching
      const itemId = item.id.toString();
      return itemId == infoId;
    });
    return (result.length > 0 && result[0]) ? result[0] : "";
  }
}
